import React from "react";
import { ButtonFluxi } from "../../common/Buttons/ButtonFluxi/ButtonFluxi";
import ConnectButton from "../PaymentMethods/PaymentMethodsCard/PaymentMethodsButtons/ConnectButton";
import { handleConnect } from "../PaymentMethods/paymentUtils";
import gifs from "../../../assets/icons/gifs.json";
const PaymentMethodsNotConfiguration: React.FC<{ id: string }> = ({ id }) => {
  return (
    <div className="flex flex-col items-center justify-center">
      <img
        src={gifs.error}
        className="w-1/2"
        alt="No se encontraron métodos de pago"
      />
      <h1 className="mt-8 mb-12 text-xl font-bold w-[300px] text-center">
        You must connect this payment method to activate it
      </h1>
      {/* <div> */}
      <ConnectButton onClick={() => handleConnect(id)} />
      {/* </div> */}
    </div>
  );
};

export default PaymentMethodsNotConfiguration;
